export const MARKETPLACE_SETUP_REQUIRED_MESSAGE =
  'A valid active AWS Marketplace agreement is required before creating an instance. Return to AWS Marketplace and click "Set up your account".';

export const getMarketplaceEligibilityError = (customer) => {
  if (!customer) {
    return MARKETPLACE_SETUP_REQUIRED_MESSAGE;
  }

  const subscriptionStatus = String(customer.subscription_status || '').toLowerCase();
  if (subscriptionStatus !== 'active') {
    return 'Customer subscription is not active.';
  }

  const activeAgreement = Array.isArray(customer.marketplace_agreements)
    ? customer.marketplace_agreements.find((agreement) => (
        String(agreement?.status || '').toLowerCase() === 'active' && agreement?.agreement_id
      ))
    : null;
  const agreementId = customer.active_agreement_id || activeAgreement?.agreement_id || '';
  if (!customer.marketplace_customer_id || !customer.license_arn || !agreementId) {
    return MARKETPLACE_SETUP_REQUIRED_MESSAGE;
  }

  return '';
};
